interface Props {
  nombre: string;
  rfc?: string;
  direccion?: string;
  mensajePieTicket?: string;
  logoSrc?: string;
}

/**
 * Vista previa del ticket impreso. Renderiza con fuente monoespaciada
 * imitando un ticket térmico de 80mm.
 */
export function TicketPreview({ nombre, rfc, direccion, mensajePieTicket, logoSrc }: Props) {
  return (
    <div className="mx-auto w-72 rounded border border-slate-300 bg-white p-4 font-mono text-xs leading-tight text-slate-800 shadow-sm">
      {logoSrc && (
        <div className="mb-2 flex justify-center">
          <img src={logoSrc} alt="Logo" className="h-16 w-16 object-contain" />
        </div>
      )}
      <div className="text-center font-bold">{nombre || 'MI RESTAURANTE'}</div>
      {rfc && <div className="text-center">RFC: {rfc}</div>}
      {direccion && <div className="text-center">{direccion}</div>}
      <div className="my-2 border-t border-dashed border-slate-400" />
      <div>Folio: 00001</div>
      <div>Fecha: --/--/----</div>
      <div className="my-2 border-t border-dashed border-slate-400" />
      <div className="flex justify-between">
        <span>1x Ejemplo</span>
        <span>$0.00</span>
      </div>
      <div className="my-2 border-t border-dashed border-slate-400" />
      <div className="flex justify-between font-bold">
        <span>TOTAL</span>
        <span>$0.00</span>
      </div>
      {mensajePieTicket && (
        <>
          <div className="my-2 border-t border-dashed border-slate-400" />
          <div className="text-center text-[10px]">{mensajePieTicket}</div>
        </>
      )}
    </div>
  );
}
